<template>
    <div class="container-md container-app p-0 ">
        <div class="wrapper login">
            <div class="content">
                <div v-if="this.reset_success">
                    <p class="text-center">
                        <i class="fa fa-check fa-3x color"></i>
                        <br><br>
                        {{$t('account.mail_recupera_inviata')}}!
                        <br>
                        {{$t('account.cntr_spam_msg')}}.
                        <br><br>
                        <router-link :to="{name:'user.login'}">
                            <button class="btn btn-primary" style="width:230px;">{{$t('account.effettua_login')}}
                            </button>
                        </router-link>
                    </p>
                </div>
                <div v-else>
                    <p>{{$t('account.ins_utente_rec_password')}}.</p>
                    <form>
                        <div class="form-group">
                            <input type="text" class="form-control" placeholder="Account *" v-model="form.account">
                        </div>
                        <router-link :to="{name:'user.login'}">
                            <button type="button" class="btn btn-default float-left">{{$t('btn_annulla')}}</button>
                        </router-link>
                        <button type="button" class="btn btn-primary float-right"
                                @click="submit()"
                                :disabled="this.loading_visible">
                            {{$t('account.recupera_btn')}}
                        </button>
                        <div class="clearfix"></div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapState, mapActions} from 'vuex';
    import {passwordRecover} from "../../../api/account";

    import ModalErrors from "../../partials/ModalErrors";

    export default {
        name: "Remember",
        components: {ModalErrors},
        data() {
            return {
                form: {
                    account: ''
                },
                reset_success: false
            }
        },
        computed: {
            ...mapState('global', {
                loading_visible: state => state.loading_visible
            }),
            ...mapState('localization', {
                language: state => state.language
            }),
            ...mapState('restaurant', {
                id_ristorante: state => state.id,
                locale: state => state.locale
            })
        },
        methods: {
            submit: function () {
                this.showLoading(true);
                passwordRecover(this.language, {
                    id_ristorante: this.id_ristorante,
                    id_locale: this.locale.id,
                    account: this.form.account
                }).then((response) => {
                    this.reset_success = true;
                }).catch(({messages}) => {
                    this.showModalErrors({
                        title: 'ACCOUNT',
                        errors: messages
                    });
                }).finally(() => {
                    this.showLoading(false);
                })
            },
            ...mapActions('global', [
                'showLoading',
                'showModalErrors'
            ])
        }
    }
</script>
